import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const MegaphoneStateTrueNofiFalseIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "MegaphoneStateTrueNofiFalseIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M21.3018 2.27891C20.8639 1.97975 20.3079 1.91807 19.8149 2.10928C19.7716 2.12573 19.7309 2.14835 19.6933 2.17611C19.6618 2.19872 16.5467 4.48511 14.782 5.13895C13.04 5.78456 10.4648 5.79382 10.4391 5.79382H6.48309C4.01098 5.79382 2 7.80057 2 10.2669C2 12.6928 3.94857 14.6629 6.36509 14.7271V19.7054C6.36509 20.9709 7.39712 22 8.66564 22C9.93467 22 10.9667 20.9709 10.9667 19.7054V14.7731C11.9108 14.8418 13.8492 15.0305 14.9809 15.4719C16.5292 16.0743 19.6654 18.3371 19.6969 18.3597C19.7335 18.3864 19.7731 18.408 19.8149 18.4244C20.0034 18.4974 20.2008 18.5334 20.3976 18.5334C20.7155 18.5334 21.0313 18.4388 21.3013 18.2548C21.7388 17.9567 22 17.4632 22 16.9348V3.59892C22 3.0705 21.7388 2.57705 21.3018 2.27891Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default MegaphoneStateTrueNofiFalseIcon;
